
import React, { useState } from "react";
import styles from './ExpandableTable.module.css';

const ExpandableTable = (props) => {
  const [expandedIds, setExpandedIds] = useState(new Set());

  const toggle = (id) => {
    setExpandedIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        // collapse: recursively remove all descendants
        collapseAll(id, dataMap, newSet);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const collapseAll = (id, map, set) => {
    set.delete(id);
    const children = map.get(id) || [];
    children.forEach((child) => collapseAll(child.id, map, set));
  };

  const buildDataMap = (items) => {
    const map = new Map();
    const flatten = (nodes) => {
      for (const node of nodes) {
        if (!map.has(node.parentId)) {
          map.set(node.parentId, []);
        }
        map.get(node.parentId).push(node);
        flatten(node.children || []);
      }
    };
    flatten(items);
    return map;
  };

  const dataMap = buildDataMap(props.data);

  const renderRows = (parentId = null, level = 0) => {
    const rows = dataMap.get(parentId) || [];
    return rows.map((row) => {
      const hasChildren = (row.children || []).length > 0;
      const isExpanded = expandedIds.has(row.id);
      return (
        <React.Fragment key={row.id}>
          <tr>
            <td style={{ paddingLeft: 10 + 20 * level }} className={styles.td + " " + styles[`rowLevel${level}`]}>
              {hasChildren && (
                <span
                  className={styles.tableExpandIcon}
                  onClick={() => toggle(row.id)}
                  style={{ cursor: "pointer", marginRight: 8 }}
                >
                  {isExpanded ? "-" : "+"}
                </span>
              )}
              {row.label}
            </td>
            <td className={styles.td + " " + styles[`rowLevel${level}`]}>{row.count == 0 ? "" : row.count}</td>
            <td className={styles.td + " " + styles[`rowLevel${level}`]}>{row.length == 0 ? "" : row.length.toFixed(2)}</td>
            <td className={styles.td + " " + styles[`rowLevel${level}`]}>{row.area == 0 ? "" : row.area.toFixed(2)}</td>
          </tr>
          {isExpanded && renderRows(row.id, level + 1)}
        </React.Fragment>
      );
    });
  };

  return (
    <div className={styles.tableContainer}>
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.th}>Title</th>
          <th className={styles.th}>Count</th>
          <th className={styles.th}>Length (Mts)</th>
          <th className={styles.th}>Area (Sq.Mts)</th>
        </tr>
      </thead>
      <tbody>{renderRows()}</tbody>
    </table>
    </div>
  );
};

export default ExpandableTable;